export const EXTENSION_VIDEO_MAP = {
    mp4:  'video/mp4',
    avi:  'video/avi',
    webm: 'video/webm',
    ogg:  'video/ogg',
    flv:  'video/x-flv',
    mkv:  'video/x-matroska'
}

export const VALUES_EXTENSION_VIDEO = ['.mp4', '.avi', '.webm', '.ogg', '.flv', '.mkv'];

export const VIDEO_EXTENSIONS = 'video/mp4, video/avi, video/webm, video/x-matroska, video/x-flv'